import { useEffect, useState } from "react";
import {
  EnumStatisticType,
  StatisticModel
} from "../../../../../server/routes/statistic/types";
import useMarketplacesFilter from "../../../components/FilterMarketplacesProvider/useFilterMarketplaces";
import { useHideFakeOrders } from "../../../components/HideFakeOrdersProvider";
import { useApi } from "../../../hooks";
import { getStatisticToday } from "../../../requests";

const useLoading = () => {
  const { status: hideFakeOrders } = useHideFakeOrders();
  const [loading, setLoading] = useState(false);
  const [statistic, setStatistic] = useState<
    { [statisticType in EnumStatisticType]: StatisticModel } | null
  >(null);
  const apiGetStatistic = useApi(getStatisticToday);
  const {
    active: filteringMarketplaces,
    isLoading: filteringMarketplacesloading,
  } = useMarketplacesFilter();

  useEffect(() => {
    setLoading(true);
    if (filteringMarketplacesloading) {
      return;
    }
    apiGetStatistic({
      hideFakeOrders: hideFakeOrders,
      marketplaceTypes:
        filteringMarketplaces.length > 0 ? filteringMarketplaces : undefined,
    })
      .then((statistic) => {
        setStatistic(statistic);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [filteringMarketplaces, hideFakeOrders]);
  return { loading, statistic };
};
export default useLoading;
